import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { logger } from 'spartacus/services/LoggerService'
import SessionStorage from 'spartacus/services/SessionStorage'
import useStores from 'spartacus/hooks/useStores'
import Typography from 'spartacus/components/Typography'
import Image from 'spartacus/components/Image'
import Colors from 'spartacus/styles/colors'
import AirplaneIllustration from './assets/airplane-illustration.png?resize'
import AirplaneIllustrationWebP from './assets/airplane-illustration.png?webp'
import * as S from './style'

const VerifyEmailStep = observer(
  (): JSX.Element => {
    const { sessionStore } = useStores()

    useEffect(() => {
      SessionStorage.remove('onboarding')
      logger.debug('[user auth 2.0 enrollment] verify email view')
    }, [])

    return (
      <S.Card>
        <S.ImageContainer>
          <Image
            src={AirplaneIllustration}
            webp={AirplaneIllustrationWebP}
            alt=""
            type="image/png"
          />
        </S.ImageContainer>

        <Typography element="h1" kind="TS4 - Strong">
          Verify your email
        </Typography>

        <Typography element="p" kind="TS2 - Regular">
          We sent a one-time verification link to {sessionStore.publicEmail}.
        </Typography>

        <Typography element="p" kind="TS2 - Regular">
          Please click the link in the email to complete your account set-up.
        </Typography>

        <Typography element="p" kind="TSL - Legal" color={Colors.Type.Secondary}>
          Check your spam folder if you don’t see the email in your inbox. Please note this can take
          up to a few minutes to send.
        </Typography>
      </S.Card>
    )
  },
)

export default VerifyEmailStep
